import { render } from "./ModalImportExcelPoliticas.vue?vue&type=template&id=c48297a8"
import script from "./ModalImportExcelPoliticas.vue?vue&type=script&lang=js"
export * from "./ModalImportExcelPoliticas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__